// extracted by mini-css-extract-plugin
module.exports = {"list":"SocialLinks_list__1JD9G"};